/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.OfferInfo';

export default defineMessages({
  services: {
    id: `${scope}.menu1`,
    defaultMessage: 'Servizi inclusi',
  },
  carSpecs: {
    id: `${scope}.menu2`,
    defaultMessage: 'Caratteristiche auto',
  },
  accessories: {
    id: `${scope}.accessories`,
    defaultMessage: 'Equipaggiamenti di serie',
  },
  notes: {
    id: `${scope}.notes`,
    defaultMessage: 'Note',
  },
  private_notes: {
    id: `${scope}.private_notes`,
    defaultMessage: 'Note venditore',
  },
  engine: {
    id: `${scope}.engine`,
    defaultMessage: 'Motore e consumi',
  },
  sizes: {
    id: `${scope}.sizes`,
    defaultMessage: 'Carrozzeria',
  },
  features: {
    id: `${scope}.features`,
    defaultMessage: 'Specifiche',
  },
  seller: {
    id: `${scope}.seller`,
    defaultMessage: 'Dati venditore',
  },
  fee: {
    id: `${scope}.fee`,
    defaultMessage: 'Commissioni',
  },
  broker: {
    id: `${scope}.broker`,
    defaultMessage: 'Info noleggio',
  },
  equippedAccessories: {
    id: `${scope}.equippedAccessories`,
    defaultMessage: 'Di serie',
  },
  equippedOptionals: {
    id: `${scope}.equippedOptionals`,
    defaultMessage: 'Optional inclusi',
  },
  colors: {
    id: `${scope}.colors`,
    defaultMessage: 'Colori',
  },
  optionalAccessories: {
    id: `${scope}.optionalAccessories`,
    defaultMessage: 'Optional',
  },

  info: {
    id: `${scope}.info`,
    defaultMessage: '*I prezzi indicati sono da sommare alla rata mensile del Noleggio a Lungo Termine. Esempio: considerando un optional il cui costo è di € 180, con una durata contrattuale di 36 mesi, il canone mensile aumenterà di € 5 al mese.',
  },


});
